import { DispositionLayoutProps, Result } from './@types/DispositionLayoutProps';

function DispositionLayout({ children }: DispositionLayoutProps): Result {
	return <>{children}</>;
}

export default DispositionLayout;
